/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DataPermissionType {
    Self = 0,
    Bookmarks = 10,
    Checklists = 20,
    Instructor = 30,
    Learner = 40,
    StandardizedPatient = 50,
    Tracking = 60,
}
